var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("thead", [
    _c(
      "tr",
      { staticClass: "assets-by-class-table__table-header" },
      [
        _vm._l(_vm.units, function(unit) {
          return [
            unit.kind === "single" &&
            unit.column.cellType === "text" &&
            _vm.isVisible(unit.key)
              ? _c(
                  "th",
                  {
                    key: "cell-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [_vm._v(" " + _vm._s(unit.column.label) + " ")]
                    )
                  ]
                )
              : unit.key === "ativo" && _vm.isVisible("ativo")
              ? _c(
                  "th",
                  {
                    key: "ativo-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    !_vm.readonly
                      ? _c("v-simple-checkbox", {
                          staticClass: "p-0 m-0",
                          attrs: {
                            dense: "",
                            "hide-details": "",
                            ripple: false,
                            value: _vm.isAllSelected,
                            indeterminate: _vm.isSomeSelected,
                            color: "primary"
                          },
                          on: { input: _vm.handleSelectAll }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [_vm._v(" Ativo ")]
                    )
                  ],
                  1
                )
              : unit.key === "instituicao" && _vm.isVisible("instituicao")
              ? _c(
                  "th",
                  {
                    key: "inst-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [_vm._v(" " + _vm._s(_vm.instituicaoLabel) + " ")]
                    )
                  ]
                )
              : unit.kind === "group" &&
                unit.group === "Saldo Bruto" &&
                _vm.saldoColspan > 0
              ? _c(
                  "th",
                  {
                    key: "saldo-" + unit.group,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col", colspan: _vm.saldoColspan }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [_vm._v(" Saldo Bruto ")]
                    )
                  ]
                )
              : unit.kind === "group" &&
                unit.group === "Rentabilidade" &&
                _vm.showRentability &&
                _vm.rentColspan > 0
              ? _c(
                  "th",
                  {
                    key: "rent-" + unit.group,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col", colspan: _vm.rentColspan }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "assets-by-class-table__table-header-text assets-by-class-table__table-header-text--loading"
                      },
                      [
                        _c("div", [_vm._v(" Rentabilidade ")]),
                        _vm.loadingRentAsset
                          ? _c("v-progress-linear", {
                              attrs: {
                                primary: "",
                                indeterminate: "",
                                height: "2"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : unit.key === "volatilidade" && _vm.isVisible("volatilidade")
              ? _c(
                  "th",
                  {
                    key: "vol-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [_vm._v(" Vol. ")]
                    )
                  ]
                )
              : unit.key === "recomendacao" && _vm.isVisible("recomendacao")
              ? _c(
                  "th",
                  {
                    key: "rec-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "360" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b({}, "span", attrs, false),
                                          on
                                        ),
                                        [_vm._v("Recomendação")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.recomendacaoTooltip))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              : unit.key === "comentario" && _vm.isVisible("comentario")
              ? _c(
                  "th",
                  {
                    key: "com-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "assets-by-class-table__table-header-text"
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "360" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b({}, "span", attrs, false),
                                          on
                                        ),
                                        [_vm._v("Comentário")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.comentarioTooltip))])]
                        )
                      ],
                      1
                    )
                  ]
                )
              : unit.key === "acoes" && _vm.showAcoes
              ? _c(
                  "th",
                  {
                    key: "acoes-" + unit.key,
                    staticClass: "assets-by-class-table__table-header-column",
                    attrs: { scope: "col" }
                  },
                  [
                    _vm._t("actions-header", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "assets-by-class-table__table-header-text"
                        },
                        [_vm._v(" Ações ")]
                      )
                    ])
                  ],
                  2
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }